var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('WorkflowFilter'),_c('DataTable',{attrs:{"rowKeys":['workflowId'],"rows":_vm.workflows,"actions":[
      {
        name: 'workflow',
        label: 'View',
        params: { workflowId: 'workflowId' }
      }
    ],"columns":[
      { name: 'workflowId', type: 'text' },
      { name: 'version', type: 'text' },
      { name: 'workflowType', type: 'text' },
      { name: 'status', type: 'text' },
      { name: 'executionTime', type: 'duration' },
      { name: 'startTime', type: 'date' },
      { name: 'endTime', type: 'date' },
      { name: 'failedReferenceTaskNames', type: 'text' },
      { name: 'reasonForIncompletion', type: 'text' }
    ]}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }